module.exports = __webpack_public_path__ + "img/state1.0dd739dc.webp";